import React from "react";
import PropTypes from "prop-types";
import { SumBlock } from "components/ui";

const formatDuration = (seconds) => {
  if (!seconds) return "0:00";
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};

const formatPercent = (value) => {
  if (value == null) return "0%";
  return `${Math.floor(value)}%`;
};

const CallQualityKpis = ({ dashboard }) => {
  if (!dashboard) {
    return (
      <div className="call-quality-kpis">
        <div className="kpi-row">
          <SumBlock title="Total Calls" value={0} />
          <SumBlock title="Connected" value="0 (0%)" tooltip="Calls where patient answered" />
          <SumBlock title="Agent Calls" value={0} />
          <SumBlock title="Live Calls" value={0} />
          <SumBlock title="Avg Score" value="0%" />
          <SumBlock title="Positive Sentiment" value="0%" />
          <SumBlock title="Excellent Calls" value={0} tooltip="Calls with 90%+ score" />
          <SumBlock title="Avg Duration" value="0:00" />
        </div>
      </div>
    );
  }

  const connectedDisplay = `${dashboard.connectedCalls || 0} (${formatPercent(dashboard.connectionRate)})`;

  return (
    <div className="call-quality-kpis">
      <div className="kpi-row">
        <SumBlock
          title="Total Calls"
          value={dashboard.totalCalls || 0}
        />
        <SumBlock
          title="Connected"
          value={connectedDisplay}
          tooltip="Calls where patient answered"
        />
        <SumBlock
          title="Agent Calls"
          value={dashboard.aiCalls || 0}
        />
        <SumBlock
          title="Live Calls"
          value={dashboard.liveCalls || 0}
        />
        <SumBlock
          title="Avg Score"
          value={formatPercent(dashboard.averageScore)}
        />
        <SumBlock
          title="Positive Sentiment"
          value={formatPercent(dashboard.positiveSentimentRate)}
        />
        <SumBlock
          title="Excellent Calls"
          value={dashboard.excellentCalls || 0}
          tooltip="Calls with 90%+ score"
        />
        <SumBlock
          title="Avg Duration"
          value={formatDuration(dashboard.averageDurationSeconds)}
        />
      </div>
    </div>
  );
};

CallQualityKpis.propTypes = {
  dashboard: PropTypes.shape({
    totalCalls: PropTypes.number,
    aiCalls: PropTypes.number,
    liveCalls: PropTypes.number,
    connectedCalls: PropTypes.number,
    connectionRate: PropTypes.number,
    averageScore: PropTypes.number,
    positiveSentimentRate: PropTypes.number,
    excellentCalls: PropTypes.number,
    averageDurationSeconds: PropTypes.number
  })
};

export default CallQualityKpis;
